import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from 'store/index';
import { CategoryIdType } from 'types/toont-tint/toon-tint';

const initialState: CategoryIdType = {
    categoryId: '',
};

const toolTintCategoryIdSlice = createSlice({
    name: 'categoryID',
    initialState,
    reducers: {
        addNewCategoryId: (state, action: PayloadAction<CategoryIdType>) => {
            state.categoryId = action.payload.categoryId || '';
        },
        deleteCategoryId: (state) => {
            state.categoryId = '';
        },
    },
});

export const { addNewCategoryId, deleteCategoryId } =
    toolTintCategoryIdSlice.actions;

export const selectCategoryIdOptions = (state: RootState) => state.categoryId;

export default toolTintCategoryIdSlice.reducer;
